// theme.js
const colors = {
    anthracite: 'rgb(40,40,45)',
    redRed: '#ee0606',
    dangerRed: '#e64c47',
    grey: '#45464c',
    lightGrey: 'rgb(237, 237, 237)',
    normalGrey: '#9c9c9c',
    barixGreen: '#008148',
    primary: ['#00e676', '#b9f6ca'],
    gray: ['#424242', '#ccc', '#f4f4f4']
};

const textStyles = {
    labelNormal: {
        fontFamily: 'sans-serif',
        fontSize: '14px',
        marginLeft: '3px',
        color: 'rgb(40,40,45)',
        height: '22px',
        lineHeight: '22px',
        wordWrap: 'break-word'
    },
    labelBold: {
        fontFamily: 'sans-serif',
        fontSize: '14px',
        fontWeight: 'bold',
        marginLeft: '3px',
        color: 'rgb(40,40,45)',
        height: '22px',
        lineHeight: '22px',
        wordWrap: 'break-word'
    },
    labelSmall: {
        fontFamily: 'sans-serif',
        fontSize: '12px',
        whiteSpace: 'pre-wrap',
        color: 'rgb(40, 40, 45)'
    }
};

const theme = {
    colors,
    textStyles,
    breakpoints: ['1200px'],
    space: [0, 2, 8, 18, 24],
    fontSizes: [12, 16, 18, 24, 36, 72]
};

export default theme;



// WEBPACK FOOTER //
// ./src/styledSystem/theme.js